import { useMemo } from 'react';
import { ConfigMap } from '../avenues/ConnectedCollectionAvenue';
import { useCollectionFavorites } from '@features/Collection/hooks/useCollectionFavorites';

export type AvenueTitle = 'bookmarks' | 'recents' | 'all';
export const AVENUE_TITLES: AvenueTitle[] = ['bookmarks', 'recents', 'all'];

export const useAvenueConfigs = () => {
    const { favorites, isLoading } = useCollectionFavorites();

    const configs = useMemo<ConfigMap>(() => {
        const safeFavorites =
            favorites.length > 0 ? favorites : ['__EMPTY_STATE__'];

        return {
            bookmarks: {
                sorting: [{ id: 'lastUpdated', desc: true }],
                facets: {
                    title_lc: safeFavorites.map((value) => ({
                        value,
                        operator: 'contains',
                    })),
                },
            },
            recents: {
                sorting: [{ id: 'lastUpdated', desc: true }],
            },
            all: {
                sorting: [{ id: 'title', desc: false }],
            },
        };
    }, [favorites]);

    return {
        configs,
        isReady: !isLoading,
    };
};
